// import actionTypes from "../actionTypes";

const initialState = {
  data: [],
  isFetching: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
